import React, { useState, createContext, useContext } from 'react';
type Lang = 'pl' | 'ua' | 'ru';
type Translations = Record<string, {
  pl: string;
  ua: string;
  ru: string;
}>;
const translations: Translations = {
  // Header / Nav
  nav_about: {
    pl: 'O nas',
    ua: 'Про нас',
    ru: 'О нас'
  },
  nav_services: {
    pl: 'Usługi',
    ua: 'Послуги',
    ru: 'Услуги'
  },
  nav_advantages: {
    pl: 'Zalety',
    ua: 'Переваги',
    ru: 'Преимущества'
  },
  nav_faq: {
    pl: 'FAQ',
    ua: 'FAQ',
    ru: 'FAQ'
  },
  nav_contacts: {
    pl: 'Kontakt',
    ua: 'Контакт',
    ru: 'Контакт'
  },
  nav_consultation: {
    pl: 'Konsultacja',
    ua: 'Консультація',
    ru: 'Консультация'
  },
  nav_order_consultation: {
    pl: 'Zamów konsultację',
    ua: 'Замовити консультацію',
    ru: 'Заказать консультацию'
  },
  // Hero
  hero_badge: {
    pl: 'Usługi księgowe dla firm',
    ua: 'Бухгалтерські послуги для бізнесу в Польщі',
    ru: 'Бухгалтерские услуги для бизнеса в Польше'
  },
  hero_h1_1: {
    pl: 'Prowadzimy Twoją księgowość.',
    ua: 'Ведемо вашу бухгалтерію.',
    ru: 'Ведём вашу бухгалтерию.'
  },
  hero_h1_2: {
    pl: 'Ty rozwijasz biznes.',
    ua: 'Ви розвиваєте бізнес.',
    ru: 'Вы развиваете бизнес.'
  },
  hero_subtitle: {
    pl: 'Profesjonalna obsługa księgowa dla jednoosobowych działalności i spółek. Deklaracje podatkowe, kadry i płace, rejestracja — wszystko pod kontrolą.',
    ua: 'Професійний бухгалтерський супровід для JDG та Sp. z o.o. в Польщі. Податкові декларації, кадри та зарплата, реєстрація — все під контролем.',
    ru: 'Профессиональное бухгалтерское сопровождение для JDG и Sp. z o.o. в Польше. Налоговые декларации, кадры и зарплата, регистрация — всё под контролем.'
  },
  hero_cta_primary: {
    pl: 'Bezpłatna konsultacja',
    ua: 'Безкоштовна консультація',
    ru: 'Бесплатная консультация'
  },
  hero_cta_secondary: {
    pl: 'Nasze usługi',
    ua: 'Наші послуги',
    ru: 'Наши услуги'
  },
  hero_trust_1: {
    pl: '10+ lat doświadczenia',
    ua: '10+ років досвіду',
    ru: '10+ лет опыта'
  },
  hero_trust_2: {
    pl: '300+ klientów',
    ua: '300+ клієнтів',
    ru: '300+ клиентов'
  },
  hero_trust_3: {
    pl: '100% na czas',
    ua: '100% вчасно',
    ru: '100% вовремя'
  },
  hero_stat_label: {
    pl: 'Terminowe rozliczenia',
    ua: 'Вчасна звітність',
    ru: 'Своевременная отчётность'
  },
  // About
  about_h2: {
    pl: 'Specjalizujemy się wyłącznie w księgowości.',
    ua: 'Ми спеціалізуємося виключно на бухгалтерії.',
    ru: 'Мы специализируемся исключительно на бухгалтерии.'
  },
  about_p1: {
    pl: 'Od 2013 roku pomagamy przedsiębiorcom i firmom prowadzić księgowość, składać deklaracje podatkowe i optymalizować podatki.',
    ua: 'З 2013 року ми допомагаємо підприємцям та компаніям у Польщі вести бухгалтерію, подавати декларації та оптимізувати оподаткування.',
    ru: 'С 2013 года мы помогаем предпринимателям и компаниям в Польше вести бухгалтерию, подавать декларации и оптимизировать налогообложение.'
  },
  about_p2: {
    pl: 'Znamy specyfikę pracy z Urzędem Skarbowym i ZUS, śledzimy wszystkie zmiany w przepisach podatkowych i jesteśmy gotowi przejąć całą papierkową robotę, abyś mógł skupić się na rozwoju swojego biznesu.',
    ua: 'Ми знаємо специфіку роботи з Urząd Skarbowy та ZUS, стежимо за всіма змінами в польському законодавстві та готові взяти на себе всю паперову роботу, щоб ви могли зосередитися на розвитку бізнесу.',
    ru: 'Мы знаем специфику работы с Urząd Skarbowy и ZUS, следим за всеми изменениями в польском законодательстве и готовы взять на себя всю бумажную работу, чтобы вы могли сосредоточиться на развитии бизнеса.'
  },
  about_stat1_label: {
    pl: 'Lat doświadczenia',
    ua: 'Років досвіду',
    ru: 'Лет опыта'
  },
  about_stat2_label: {
    pl: 'Klientów',
    ua: 'Клієнтів',
    ru: 'Клиентов'
  },
  about_stat3_label: {
    pl: 'Złożonych deklaracji',
    ua: 'Поданих декларацій',
    ru: 'Поданных деклараций'
  },
  about_stat4_label: {
    pl: 'Na czas',
    ua: 'Вчасно',
    ru: 'Вовремя'
  },
  about_caption: {
    pl: 'Profesjonalna księgowość',
    ua: 'Професійна бухгалтерія',
    ru: 'Профессиональная бухгалтерия'
  },
  // Services
  services_h2: {
    pl: 'Usługi',
    ua: 'Послуги',
    ru: 'Услуги'
  },
  services_subtitle: {
    pl: 'Pełen zakres usług księgowych dla Twojej firmy w Polsce.',
    ua: 'Повний спектр бухгалтерських послуг для вашого бізнесу в Польщі.',
    ru: 'Полный спектр бухгалтерских услуг для вашего бизнеса в Польше.'
  },
  services_all: {
    pl: 'Wszystkie usługi',
    ua: 'Всі послуги',
    ru: 'Все услуги'
  },
  services_footer: {
    pl: 'Indywidualne podejście do każdego klienta',
    ua: 'Індивідуальний підхід до кожного клієнта',
    ru: 'Индивидуальный подход к каждому клиенту'
  },
  svc1_title: {
    pl: 'Prowadzenie księgowości',
    ua: 'Ведення бухгалтерії',
    ru: 'Ведение бухгалтерии'
  },
  svc1_desc: {
    pl: 'Pełna obsługa księgowa dla JDG i spółek — KPiR, pełna księgowość, ryczałt.',
    ua: 'Повне бухгалтерське обслуговування для JDG та Sp. z o.o. — KPiR, повна бухгалтерія, ryczałt.',
    ru: 'Полное бухгалтерское обслуживание для JDG и Sp. z o.o. — KPiR, полная бухгалтерия, ryczałt.'
  },
  svc1_price: {
    pl: 'od 500 zł/mies.',
    ua: 'від 500 zł/міс.',
    ru: 'от 500 zł/мес.'
  },
  svc2_title: {
    pl: 'Deklaracje podatkowe',
    ua: 'Податкові декларації',
    ru: 'Налоговые декларации'
  },
  svc2_desc: {
    pl: 'Przygotowanie i składanie PIT, VAT, CIT oraz deklaracji ZUS do właściwych urzędów.',
    ua: 'Підготовка та подання PIT, VAT, CIT і декларацій ZUS до відповідних органів.',
    ru: 'Подготовка и подача PIT, VAT, CIT и деклараций ZUS в соответствующие органы.'
  },
  svc2_price: {
    pl: 'od 200 zł',
    ua: 'від 200 zł',
    ru: 'от 200 zł'
  },
  svc3_title: {
    pl: 'Rejestracja JDG / Sp. z o.o.',
    ua: 'Реєстрація JDG / Sp. z o.o.',
    ru: 'Регистрация JDG / Sp. z o.o.'
  },
  svc3_desc: {
    pl: 'Rejestracja działalności w CEIDG lub KRS, wybór formy opodatkowania, otwarcie rachunku.',
    ua: 'Реєстрація бізнесу в CEIDG або KRS, вибір форми оподаткування, відкриття рахунку.',
    ru: 'Регистрация бизнеса в CEIDG или KRS, выбор формы налогообложения, открытие счёта.'
  },
  svc3_price: {
    pl: 'od 300 zł',
    ua: 'від 300 zł',
    ru: 'от 300 zł'
  },
  svc4_title: {
    pl: 'Kadry i płace',
    ua: 'Кадри та зарплата',
    ru: 'Кадры и зарплата'
  },
  svc4_desc: {
    pl: 'Naliczanie wynagrodzeń, składek ZUS, L4 i urlopów. Prowadzenie dokumentacji kadrowej.',
    ua: 'Нарахування зарплат, внесків ZUS, лікарняних та відпусток. Ведення кадрової документації.',
    ru: 'Начисление зарплат, взносов ZUS, больничных и отпускных. Ведение кадровой документации.'
  },
  svc4_price: {
    pl: 'od 150 zł/mies.',
    ua: 'від 150 zł/міс.',
    ru: 'от 150 zł/мес.'
  },
  svc5_title: {
    pl: 'Doradztwo podatkowe',
    ua: 'Податкові консультації',
    ru: 'Налоговые консультации'
  },
  svc5_desc: {
    pl: 'Analiza obciążeń podatkowych, optymalizacja i planowanie podatkowe dla Twojej firmy.',
    ua: 'Аналіз податкового навантаження, оптимізація та планування для вашого бізнесу в Польщі.',
    ru: 'Анализ налоговой нагрузки, оптимизация и планирование для вашего бизнеса в Польше.'
  },
  svc5_price: {
    pl: 'od 180 zł',
    ua: 'від 180 zł',
    ru: 'от 180 zł'
  },
  svc6_title: {
    pl: 'Odtworzenie ksiąg',
    ua: 'Відновлення обліку',
    ru: 'Восстановление учёта'
  },
  svc6_desc: {
    pl: 'Odtworzenie ksiąg rachunkowych za poprzednie okresy. Korekta błędów i zaległości podatkowych.',
    ua: 'Відновлення бухгалтерського обліку за попередні періоди. Виправлення помилок та заборгованостей.',
    ru: 'Восстановление бухгалтерского учёта за предыдущие периоды. Исправление ошибок и задолженностей.'
  },
  svc6_price: {
    pl: 'Wycena indywidualna',
    ua: 'Індивідуальна оцінка',
    ru: 'Индивидуальная оценка'
  },
  // WhyChooseUs
  why_h2: {
    pl: 'Dlaczego wybierają nas',
    ua: 'Чому обирають нас',
    ru: 'Почему выбирают нас'
  },
  why1_title: {
    pl: 'Doświadczenie i kwalifikacje',
    ua: 'Досвід та кваліфікація',
    ru: 'Опыт и квалификация'
  },
  why1_desc: {
    pl: 'Certyfikowani księgowi z 10+ latami praktyki. Na bieżąco śledzimy zmiany w polskim prawie podatkowym.',
    ua: 'Сертифіковані бухгалтери з 10+ роками практики. Постійно стежимо за змінами в польському податковому законодавстві.',
    ru: 'Сертифицированные бухгалтеры с 10+ годами практики. Постоянно следим за изменениями в польском налоговом законодательстве.'
  },
  why2_title: {
    pl: 'Dotrzymywanie terminów',
    ua: 'Дотримання термінів',
    ru: 'Соблюдение сроков'
  },
  why2_desc: {
    pl: 'Zero kar za spóźnione deklaracje. Śledzimy wszystkie terminy US i ZUS i przypominamy z wyprzedzeniem.',
    ua: 'Жодних штрафів за запізнілі декларації. Стежимо за всіма термінами Urząd Skarbowy та ZUS і нагадуємо заздалегідь.',
    ru: 'Никаких штрафов за просроченные декларации. Следим за всеми сроками Urząd Skarbowy и ZUS и напоминаем заранее.'
  },
  why3_title: {
    pl: 'Przejrzystość',
    ua: 'Прозорість',
    ru: 'Прозрачность'
  },
  why3_desc: {
    pl: 'Stałe ceny bez ukrytych opłat. Zawsze wiesz, za co płacisz.',
    ua: 'Фіксовані ціни без прихованих платежів. Ви завжди знаєте, за що платите.',
    ru: 'Фиксированные цены без скрытых платежей. Вы всегда знаете, за что платите.'
  },
  why4_title: {
    pl: 'Poufność',
    ua: 'Конфіденційність',
    ru: 'Конфиденциальность'
  },
  why4_desc: {
    pl: 'Pełna poufność Twoich danych finansowych. Umowa o zachowaniu poufności z każdym klientem.',
    ua: 'Повна конфіденційність ваших фінансових даних. Угода про нерозголошення з кожним клієнтом.',
    ru: 'Полная конфиденциальность ваших финансовых данных. Соглашение о неразглашении с каждым клиентом.'
  },
  // FAQ
  faq_h2: {
    pl: 'FAQ',
    ua: 'FAQ',
    ru: 'FAQ'
  },
  faq_subtitle: {
    pl: 'Odpowiedzi na najczęstsze pytania dotyczące usług księgowych w Polsce.',
    ua: 'Відповіді на найпоширеніші запитання про бухгалтерські послуги в Польщі.',
    ru: 'Ответы на самые частые вопросы о бухгалтерских услугах в Польше.'
  },
  faq_ask: {
    pl: 'Zadaj własne pytanie',
    ua: 'Поставити своє запитання',
    ru: 'Задать свой вопрос'
  },
  faq1_q: {
    pl: 'Czy jednoosobowa działalność gospodarcza potrzebuje księgowego?',
    ua: 'Чи потрібен бухгалтер для JDG в Польщі?',
    ru: 'Нужен ли бухгалтер для JDG в Польше?'
  },
  faq1_a: {
    pl: 'Formalnie JDG może prowadzić uproszczoną księgowość samodzielnie, jednak błędy w deklaracjach prowadzą do kar ze strony Urzędu Skarbowego. Księgowy gwarantuje poprawność i terminowość składania dokumentów oraz pomoże zoptymalizować podatki.',
    ua: 'Формально JDG може вести спрощену бухгалтерію самостійно, однак помилки в деклараціях призводять до штрафів з боку Urząd Skarbowy. Бухгалтер гарантує правильність і своєчасність подання документів та допоможе оптимізувати податки.',
    ru: 'Формально JDG может вести упрощённую бухгалтерию самостоятельно, однако ошибки в декларациях приводят к штрафам со стороны Urząd Skarbowy. Бухгалтер гарантирует правильность и своевременность подачи документов и поможет оптимизировать налоги.'
  },
  faq2_q: {
    pl: 'Ile kosztuje miesięczna obsługa księgowa?',
    ua: 'Скільки коштує щомісячне бухгалтерське обслуговування?',
    ru: 'Сколько стоит ежемесячное бухгалтерское обслуживание?'
  },
  faq2_a: {
    pl: 'Koszt zależy od liczby dokumentów i formy opodatkowania. JDG bez pracowników — od 500 zł/mies., spółka z o.o. — od 900 zł/mies. Dokładną wycenę przygotowujemy po analizie Twojej działalności.',
    ua: 'Вартість залежить від кількості документів та форми оподаткування. JDG без працівників — від 500 zł/міс., Sp. z o.o. — від 900 zł/міс. Точну ціну розраховуємо після аналізу вашої діяльності.',
    ru: 'Стоимость зависит от количества документов и формы налогообложения. JDG без сотрудников — от 500 zł/мес., Sp. z o.o. — от 900 zł/мес. Точную цену рассчитываем после анализа вашей деятельности.'
  },
  faq3_q: {
    pl: 'Jak często należy składać deklaracje podatkowe?',
    ua: 'Як часто потрібно подавати податкові декларації в Польщі?',
    ru: 'Как часто нужно подавать налоговые декларации в Польше?'
  },
  faq3_a: {
    pl: 'Zależy od formy opodatkowania: podatnicy VAT składają deklaracje miesięcznie lub kwartalnie, roczne PIT — raz w roku do 30 kwietnia. Śledzimy wszystkie terminy i składamy deklaracje na czas.',
    ua: 'Залежить від форми оподаткування: платники VAT подають декларації щомісяця або щокварталу, річний PIT — раз на рік до 30 квітня. Ми стежимо за всіма термінами та подаємо декларації вчасно.',
    ru: 'Зависит от формы налогообложения: плательщики VAT подают декларации ежемесячно или ежеквартально, годовой PIT — раз в год до 30 апреля. Мы следим за всеми сроками и подаём декларации вовремя.'
  },
  faq4_q: {
    pl: 'Czy obsługujecie cudzoziemców prowadzących działalność w Polsce?',
    ua: 'Чи обслуговуєте іноземців, які ведуть бізнес у Польщі?',
    ru: 'Обслуживаете ли вы иностранцев, ведущих бизнес в Польше?'
  },
  faq4_a: {
    pl: 'Tak, mamy doświadczenie w obsłudze cudzoziemców zakładających JDG lub spółki w Polsce, a także przedsiębiorców uzyskujących dochody z zagranicy (Upwork, Fiverr, kontrakty zagraniczne).',
    ua: 'Так, ми маємо досвід роботи з іноземцями, які відкривають JDG або Sp. z o.o. в Польщі, а також з підприємцями, які отримують доходи з-за кордону (Upwork, Fiverr, іноземні контракти).',
    ru: 'Да, у нас есть опыт работы с иностранцами, открывающими JDG или Sp. z o.o. в Польше, а также с предпринимателями, получающими доходы из-за рубежа (Upwork, Fiverr, иностранные контракты).'
  },
  faq5_q: {
    pl: 'Czym jest ryczałt i jaką formę opodatkowania wybrać?',
    ua: 'Що таке ryczałt і яку форму оподаткування обрати в Польщі?',
    ru: 'Что такое ryczałt и какую форму налогообложения выбрать в Польше?'
  },
  faq5_a: {
    pl: 'Ryczałt od przychodów ewidencjonowanych to uproszczona forma opodatkowania dla małych firm. Wybór między ryczałtem, KPiR a pełną księgowością zależy od rodzaju działalności i przychodów. Na konsultacji pomożemy wybrać optymalny wariant dla Ciebie.',
    ua: 'Ryczałt od przychodów ewidencjonowanych — це спрощена форма оподаткування для малого бізнесу. Вибір між ryczałt, KPiR та повною бухгалтерією залежить від виду діяльності та доходів. На консультації ми допоможемо обрати оптимальний варіант саме для вас.',
    ru: 'Ryczałt od przychodów ewidencjonowanych — это упрощённая форма налогообложения для малого бизнеса. Выбор между ryczałt, KPiR и полной бухгалтерией зависит от вида деятельности и доходов. На консультации мы поможем выбрать оптимальный вариант именно для вас.'
  },
  faq6_q: {
    pl: 'Czy oferujecie pilne konsultacje?',
    ua: 'Чи надаєте термінові консультації?',
    ru: 'Предоставляете ли срочные консультации?'
  },
  faq6_a: {
    pl: 'Tak, rozumiemy, że kwestie podatkowe bywają pilne. Skontaktuj się z nami przez Telegram lub WhatsApp, a odpowiemy najszybciej jak to możliwe.',
    ua: "Так, ми розуміємо, що податкові питання бувають невідкладними. Зв'яжіться з нами через Telegram або WhatsApp, і ми відповімо якнайшвидше.",
    ru: 'Да, мы понимаем, что налоговые вопросы бывают неотложными. Свяжитесь с нами через Telegram или WhatsApp, и мы ответим как можно скорее.'
  },
  // Contact
  contact_h2: {
    pl: 'Kontakt',
    ua: 'Контакт',
    ru: 'Контакт'
  },
  contact_subtitle: {
    pl: 'Zostaw zapytanie, a nasz księgowy skontaktuje się z Tobą w celu bezpłatnej konsultacji.',
    ua: "Залиште запит, і наш бухгалтер зв'яжеться з вами для безкоштовної консультації.",
    ru: 'Оставьте запрос, и наш бухгалтер свяжется с вами для бесплатной консультации.'
  },
  contact_phone_label: {
    pl: 'Telefon',
    ua: 'Телефон',
    ru: 'Телефон'
  },
  contact_email_label: {
    pl: 'E-mail',
    ua: 'E-mail',
    ru: 'E-mail'
  },
  contact_office_label: {
    pl: 'Biuro',
    ua: 'Офіс',
    ru: 'Офис'
  },
  contact_form_title: {
    pl: 'Formularz kontaktowy',
    ua: "Форма зв'язку",
    ru: 'Форма связи'
  },
  contact_name_label: {
    pl: 'Imię i nazwisko',
    ua: "Ім'я та прізвище",
    ru: 'Имя и фамилия'
  },
  contact_name_placeholder: {
    pl: 'Jan Kowalski',
    ua: 'Іван Коваленко',
    ru: 'Иван Коваленко'
  },
  contact_phone_input_label: {
    pl: 'Telefon',
    ua: 'Телефон',
    ru: 'Телефон'
  },
  contact_message_label: {
    pl: 'Wiadomość',
    ua: 'Повідомлення',
    ru: 'Сообщение'
  },
  contact_message_placeholder: {
    pl: 'Opisz swoją sytuację...',
    ua: 'Опишіть вашу ситуацію...',
    ru: 'Опишите вашу ситуацию...'
  },
  contact_submit: {
    pl: 'Wyślij',
    ua: 'Надіслати',
    ru: 'Отправить'
  },
  contact_privacy: {
    pl: 'Klikając przycisk, wyrażasz zgodę na przetwarzanie danych osobowych zgodnie z RODO.',
    ua: 'Натискаючи кнопку, ви погоджуєтесь на обробку персональних даних відповідно до RODO.',
    ru: 'Нажимая кнопку, вы соглашаетесь на обработку персональных данных в соответствии с RODO.'
  },
  contact_success_title: {
    pl: 'Zapytanie wysłane',
    ua: 'Запит надіслано',
    ru: 'Запрос отправлен'
  },
  contact_success_subtitle: {
    pl: 'Skontaktujemy się z Tobą wkrótce.',
    ua: "Ми зв'яжемося з вами найближчим часом.",
    ru: 'Мы свяжемся с вами в ближайшее время.'
  },
  contact_error: {
    pl: 'Błąd wysyłania. Spróbuj ponownie lub skontaktuj się bezpośrednio.',
    ua: "Помилка надсилання. Спробуйте ще раз або зв'яжіться напряму.",
    ru: 'Ошибка отправки. Попробуйте ещё раз или свяжитесь напрямую.'
  },
  // Footer
  footer_desc: {
    pl: 'Profesjonalne usługi księgowe dla JDG i spółek w Polsce. Deklaracje podatkowe, kadry i płace, rejestracja działalności.',
    ua: 'Професійні бухгалтерські послуги для JDG та Sp. z o.o. в Польщі. Податкові декларації, кадри та зарплата, реєстрація бізнесу.',
    ru: 'Профессиональные бухгалтерские услуги для JDG и Sp. z o.o. в Польше. Налоговые декларации, кадры и зарплата, регистрация бизнеса.'
  },
  footer_nav_title: {
    pl: 'Nawigacja',
    ua: 'Навігація',
    ru: 'Навигация'
  },
  footer_contacts_title: {
    pl: 'Kontakt',
    ua: 'Контакт',
    ru: 'Контакт'
  },
  footer_rights: {
    pl: 'Wszelkie prawa zastrzeżone.',
    ua: 'Всі права захищені.',
    ru: 'Все права защищены.'
  },
  footer_privacy: {
    pl: 'Polityka prywatności',
    ua: 'Політика конфіденційності',
    ru: 'Политика конфиденциальности'
  },
  footer_terms: {
    pl: 'Warunki korzystania',
    ua: 'Умови використання',
    ru: 'Условия использования'
  }
};
interface LanguageContextType {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: (key: string) => string;
}
const LanguageContext = createContext<LanguageContextType>({
  lang: 'pl',
  setLang: () => {},
  t: key => key
});
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLang] = useState<Lang>('pl');
  const t = (key: string): string => {
    const entry = translations[key];
    if (!entry) return key;
    return entry[lang] ?? entry['pl'] ?? key;
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-374">
      {children}
    </LanguageContext.Provider>;
}
export function useLang() {
  return useContext(LanguageContext);
}